import React, { useState, useEffect } from 'react'

// reactstrap components
import {
	Card,
	Button,
	CardHeader,
	CardBody,
	Collapse,
	FormGroup,
	Label,
	Input,
	Table,
	Row,
	Col
} from "reactstrap";
import { Link, useLocation } from 'react-router-dom'
import * as moment from "moment";

import { STATUS_LIST, ROLES_MAP, ROLES_CONSTANTS, DATE_FORMATS, MESSAGES, PAGE_LIMIT } from '../../configs/constant'
import { USERS, DISTRICTS, DEPARTMENT } from '../../configs/urls'
import { getApi, deleteApi } from '../../services/api'

import Toaster from "../../components/Toaster";
import Loader from '../../components/Loader'

import { FaEdit } from 'react-icons/fa'

import axios from 'axios'
import { getLoggedInUser } from '../../services/localstorage'

const Users = () => {

	const location = useLocation();
	let role = ROLES_MAP[location.pathname.replace('/admin/', '')]
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [isLoading, setIsLoading] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false);

	const [districts, setDistricts] = useState([])
	const [departments, setDepartments] = useState([])
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT,
	})
	const [isRequesting, setIsRequestig] = useState(false);
	const [params, setParams] = useState({ role_id: role, active: 1 })
	const [users, setUsersList] = useState([])
	const [newUserOperationText, setNewUserOperationText] = useState('Add New User')
	const isDistrictOfficer = (params.role_id == ROLES_MAP['district_officer']
		|| params.role_id == ROLES_MAP['dpm']
		|| params.role_id == ROLES_MAP['field_officer'])
	const isDepartmentOfficer = (params.role_id == ROLES_MAP['department_officer'] 
		|| params.role_id == ROLES_MAP['field_officer'])
	
	const loggedInUser = getLoggedInUser();

	useEffect(() => {

		const userRole = ROLES_CONSTANTS.find(r => r.id == role)
		if (userRole) {
			setNewUserOperationText(`Add New ${userRole.title}`)
		}

		getAllData()

		return function () {
			/**
			 * Add cleanup code here
			 */
			// setIsRequestig(false);
		};
	}, []);

	const getAllData = () => {
		setIsRequestig(true);

		const users = getApi(USERS, {...params, ...filterParams})
		let districts
		let departments

		if (isDistrictOfficer) {
			districts = getApi(DISTRICTS)
		}

		if (isDepartmentOfficer) {
			departments = getApi(DEPARTMENT)
		}

		axios.all([users, districts, departments]).then(res => {

			if (res[0] && res[0].data) {
				setUsersList(res[0].data)
				setCanShowLoadMore(res[0].data.length < res[0].meta.total)
			}

			if (res[1] && res[1].data) {
				setDistricts(res[1].data)
			}

			if (res[2] && res[2].data) {
				setDepartments(res[2].data)
			}

		}).catch(err => {
			console.log(err);
		}).finally(() => {
			setIsRequestig(false);
		})
	}

	const deleteUser = (userId) => {
		var proceed = window.confirm("Are you sure you want to delete User?");
		if (proceed) {
			deleteApi(`${USERS}/${userId}`)
				.then((res) => {
					let list = users
					list = list.filter(item => item.id != userId)
					setUsersList(list)
					Toaster.showSuccess(res.message || 'User deleted successfully.')
				}, (err) => {
					Toaster.showError(err.message)
				})
		}
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const fetchUsers = (isReset = false, isLoadMore) => {
		setIsLoading(true);

		const fParams = JSON.parse(JSON.stringify(filterParams))

		for (const key in fParams) {
			if ((!fParams[key] && fParams[key] != 0) || fParams[key] == -1) {
				delete fParams[key]
			}
		}

		let filters = params

		if (!isReset) {
			filters = { ...params, ...fParams }
		}

		getApi(USERS, filters)
			.then((res) => {
				let userData = isLoadMore ? [...users, ...res.data] : res.data;
				setUsersList(userData || []);
				setCanShowLoadMore(userData.length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				setIsLoading(false);
			})
	}

	const resetFilter = () => {
		setFilterParams({
			name: '',
			mobile_no: '',
			username: '',
			email: '',
			status: -1,
			district_id: -1,
			department_id: -1,
			page: 0,
			size: PAGE_LIMIT
		})

		fetchUsers(true)
	}

	const searchUsers = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		fetchUsers(false);
	}

	const loadMoreUsers = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		fetchUsers(false, true);
	}

	const renderFilters = () => (
		<>
			<CardHeader className="header-section">
				<div>
					<Button color="primary" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filters</Button>
				</div>
				{
					(loggedInUser.role_id == ROLES_MAP.administrator || loggedInUser.role_id == ROLES_MAP.super_admin) && 
					<Link to={`users/operations/${params.role_id}`}>
						<Button color="primary">{newUserOperationText}</Button>
					</Link>
				}
			</CardHeader>
			<Collapse isOpen={isFilterOpen} className="border-top">
				<Card>
					<CardBody>
						<Row>
							<Col className="pr-1" md="4" sm="4">
								<FormGroup>
									<label>Name</label>
									<Input
										type="text"
										name="name"
										placeholder="Name"
										value={filterParams.name || ""}
										onChange={handleChange}
									/>
								</FormGroup>
							</Col>
							<Col className="pr-1" md="4" sm="4">
								<FormGroup>
									<label>Username</label>
									<Input
										type="text"
										name="username"
										placeholder="Username"
										value={filterParams.username || ""}
										onChange={handleChange}
									/>
								</FormGroup>
							</Col>
							<Col className="pm-1" md="4" sm="4">
								<FormGroup>
									<label>Mobile number</label>
									<Input
										type="text"
										maxLength={"10"}
										name="mobile_no"
										placeholder="Mobile Number"
										value={filterParams.mobile_no || ""}
										onChange={handleChange}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className="pr-1" md="4" sm="4">
								<FormGroup>
									<label>Email</label>
									<Input
										type="text"
										name="email"
										placeholder="Email"
										value={filterParams.email || ""}
										onChange={handleChange}
									/>
								</FormGroup>
							</Col>
							{isDistrictOfficer &&
								<Col className="pr-1" md="4" sm="4">
									<FormGroup>
										<Label for="status">District</Label>
										<Input
											type="select"
											name="district_id"
											value={filterParams.district_id}
											onChange={handleChange}
										>
											<option value={-1}>Select District</option>
											{
												districts.map(district => (
													<option key={district.id} value={district.id}>{district.name}</option>
												))
											}
										</Input>
									</FormGroup>
								</Col>
							}
							{
								isDepartmentOfficer &&
								<Col className="pr-1" md="4" sm="4">
									<FormGroup>
										<Label for="status">Department</Label>
										<Input
											type="select"
											name="department_id"
											value={filterParams.department_id}
											onChange={handleChange}
										>
											<option value={-1}>Select Department</option>
											{
												departments.map(departments => (
													<option key={departments.id} value={departments.id}>{departments.name}</option>
												))
											}
										</Input>
									</FormGroup>
								</Col>
							}
							<Col className="pr-1" md="4" sm="4">
								<FormGroup>
									<Label for="status">Status</Label>
									<Input
										type="select"
										name="status"
										value={filterParams.status}
										onChange={handleChange}
									>
										{
											STATUS_LIST.map(status => (
												<option key={status.id} value={status.id}>{status.title}</option>
											))
										}
									</Input>
								</FormGroup>
							</Col>

							<Col className="pl-1" md="4">
								<div className="update ml-auto mt-3 mr-auto">
									<Button className="btn-round" onClick={() => searchUsers()} color="primary">
										Search
									</Button>
									<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
										Reset
									</Button>
								</div>
							</Col>
						</Row>
					</CardBody>
				</Card>
			</Collapse>
			<hr />
		</>
	)

	const renderUsers = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						{renderFilters()}
						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th className="text-center">Photo</th>
										<th>Name</th>
										<th>Username</th>
										<th>Mobile No.</th>
										<th>Email</th>
										{isDepartmentOfficer && <th>Department</th>}
										{isDistrictOfficer && <th>District</th>}
										<th>Status</th>
										<th>Last Update</th>
										{	
											(loggedInUser.role_id == ROLES_MAP.administrator || loggedInUser.role_id == ROLES_MAP.super_admin) && 
											<th className="text-right">Actions</th>
										}
									</tr>
								</thead>
								<tbody>
									{users.map((user, idx) => (
										<tr key={user.id}>
											<td>{user.id}</td>
											<td className="text-center">{
												user.profile_pic
													? <img src={'https://www.google.com/chrome/static/images/homepage/laptop_desktop.png'} height={40} />
													: <img src={require('../../assets/img/logo-small.png')} height={40} />}
											</td>
											<td>{user.name}</td>
											<td>{user.username}</td>
											<td>{user.mobile_no || '--'}</td>
											<td>{user.email || '--'}</td>
											{isDepartmentOfficer && <td>{user.department ? user.department.name : '--'}</td>}
											{isDistrictOfficer && <td>{user.district ? user.district.name : '--'}</td>}
											<td>{user.status == 1 ? 'Enabled' : 'Disabled'}</td>
											<td>{user.updated_at ? moment(user.updated_at).format(DATE_FORMATS.DATE_TIME_FORMAT) : '--'}</td>
											{
												(loggedInUser.role_id == ROLES_MAP.administrator || loggedInUser.role_id == ROLES_MAP.super_admin) &&
												<td className="text-right action-icons">
													<Link to={`users/operations/${params.role_id}/${user.id}`}>
														<FaEdit />
													</Link>
												</td>
											}
										</tr>
									))}
								</tbody>
							</Table>
							{
								users.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreUsers()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderUsers()
			}
		</>
	)
}

export default Users